<template>
  <v-app id="app" :dark="$vuetify.theme.dark" :class="`${!$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'}`">
    <router-view />
    <Snackbar />
    <Progressbar />
  </v-app>
</template>

<script>
import Snackbar from "@/components/barComponents/Snackbar";
import Progressbar from "@/components/barComponents/Progressbar.vue";
export default {
  name: "App",

  components: {
    Snackbar,
    Progressbar,
  },
};
</script>

<style>
/* .primary {
  background-image: linear-gradient(
    135deg,
    #1ebbf0 30%,
    #39dfaa 100%
  ) !important;
} */
</style>

<style lang="scss">
/* width */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $primary;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $primary_darken;
}

.grecaptcha-badge {
  visibility: hidden;
}
</style>
